<vp-footer
	[bottomItems]="bottomMenu() | menuItems"
	[company]="hotelStore.company()"
	[editableInStoryblok]="_editable()"
	[information]="hotelStore.hotelMainContact()"
	[menu]="{ items: footerMenuItems() }"
	[socials]="socials()"
	[title]="hotelStore.slug() || title()"
	[usps]="usps() | menuItems"
/>
